import { spacing, fontSize, borderRadius, lineHeight } from '../../theme/theme';
import { Input } from '../TextField/styles';

import styled from 'styled-components';

export const SelectWrap = styled(Input)`
  select {
    height: ${spacing.huge}px;
    padding: ${spacing.md}px ${spacing.md}px;
    background: #ffffff;
    border: 1px solid #c4c4c4;
    box-sizing: border-box;
    font-family: Oxygen;
    display: block;
    font-style: normal;
    font-weight: normal;
    font-size: ${fontSize.base};
    line-height: ${lineHeight.base};
    outline: 0;
    border-top-left-radius: ${({ topLeftCornerRadius }) =>
      topLeftCornerRadius ? borderRadius.base : '0'};
    border-top-right-radius: ${({ topRightCornerRadius }) =>
      topRightCornerRadius ? borderRadius.base : '0'};
    border-bottom-left-radius: ${({ bottomLeftCornerRadius }) =>
      bottomLeftCornerRadius ? borderRadius.base : '0'};
    border-bottom-right-radius: ${({ bottomRightCornerRadius }) =>
      bottomRightCornerRadius ? borderRadius.base : '0'};
    width: 100%;
  }
`;
